/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
let getAccessTokenSilently: any = null;

export const customAuth = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (func: any) => (getAccessTokenSilently = func),
};
